import { render, staticRenderFns } from "./BPView.vue?vue&type=template&id=2ea1b5f0"
import script from "./BPView.vue?vue&type=script&lang=js"
export * from "./BPView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports